import { CustomerBrowserData } from '@up/data';

export class BillingInvoicesGenerationDto {
  merchantBusinessEntityId?: number;
  merchantId?: number;
  billingSubscriptionId?: number;
  billingProductId?: number;
  customerBrowserData?: CustomerBrowserData;
  userId?: number;
  isSubscriptionChange?: boolean;
}
